<template>
    <div class="email-provider-error">
        <div class="email-provider-error__illustration">
            <img src="/ressources/logged/img/illustrations/sync-error.svg" />
        </div>

        <div class="email-provider-error__content">
            <span class="email-provider-error__title typographies-paragraph-large-semibold">
                {{
                    $t.__('email.EmailProviderError.sync_error', {
                        userEmail: currentUserEmail,
                    })
                }}
            </span>
            <br />
            <span class="email-provider-error__description typographies-paragraph-medium-regular">
                {{ $t.__('email.EmailProviderError.sync_error_try_to_reconnect') }}
            </span>
        </div>

        <CompassButton
            :label="$t.__('common.labels.access_settings')"
            class="email-provider-error__button"
            @click="goToUrl('/settings/email')"
        />

        <div class="email-provider-error__footer">
            <span class="email-provider-error__footer-text typographies-paragraph-medium-regular">
                {{ $t.__('common.labels.if_problem_persists_please') }}
            </span>
            <CompassPlainButton
                :label="$t.__('common.labels.contact_support')"
                @click="handleContactSupport"
            />
        </div>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import Feature from 'Services/Feature';

export default {
    data() {
        return {
            currentUserEmail: '',
        };
    },
    created() {
        this.currentUserEmail = this.$store.state.user.email;
    },
    methods: {
        goToUrl,
        handleContactSupport() {
            if (Feature.isEnabled('intercom')) {
                window.Intercom('show');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.email-provider-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-3);
    padding: var(--spacing-5);

    &__illustration {
        text-align: center;
        margin-bottom: var(--spacing-3);
    }

    &__content {
        color: var(--colors-common-text-standard-default);
        text-align: center;
    }

    &__button {
        margin-bottom: var(--spacing-1);
    }

    &__footer {
        color: var(--colors-common-text-standard-caption);
        text-align: center;
        text-transform: capitalize;

        :deep() {
            .compass-plain-button__label {
                text-transform: lowercase;
            }
        }
    }
}
</style>
